<template>
  <v-container fill-height class="pt-12">
    <v-layout align-center justify-center>
      <v-card tile>
        <v-card-title
          class="headlin2 indigo--text justify-center font-weight-black"
          color="#4862ab"
        >
          <h1>(m)othertongues</h1>
        </v-card-title>
        <v-img
          src="../../assets/CoverPageImage/CoverPage.jpg"
          max-height="1000"
          max-width="700"
          contain
        ></v-img>
        <v-list-item>
          <v-list-item-content>
            <v-btn
              text
              class="headline text-center cfsText red--text font-weight-bold"
              @click="goCFS"
            >Call For Submission</v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  methods: {
    goCFS: function() {
      this.$router.push({ name: "CFS" });
    }
  }
};
</script>

<style scoped>
.cfsText {
  text-transform: none !important;
}
</style>